import { render, staticRenderFns } from "./SkillBar.vue?vue&type=template&id=477864cb&scoped=true&"
import script from "./SkillBar.vue?vue&type=script&lang=js&"
export * from "./SkillBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477864cb",
  null
  
)

export default component.exports